export default "__VITE_ASSET__20iSMVKi__"